import React from "react";
import Navbar from "../components/navbar";
import Hero from "../components/hero";
import Footer from "../components/footer";
import aboutMe from "../assets/aboutme.jpg";
import "../styles/universal.css";
import "../styles/aboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-page">
      <Navbar />
      <Hero
        title="About Me"
        subtitle="I’m here to support you through your challenges, your changes, and your growth."
      />

      <div className="about-me-content">
        <h1>Welcome! I am Erin Robinson</h1>
        <div className="introduction-underlay">
          <div className="introduction">
            <div className="introduction-left">
              <img src={aboutMe} alt="Erin Robinson"></img>
              <p>
                I am a <strong>Registered Counsellor</strong> with the Health
                Professions Council of South Africa (HPCSA) with experience
                providing primary mental health services in educational and
                community-based settings.
              </p>
              <blockquote className="credentials">
                <strong>
                  HPCSA NO. PRC0045160 | Practice NO. 1266004
                  <br />
                  BPsych Registered Counsellor (Cum Laude)
                  <br />
                  BHSc Hons in Psychology
                  <br />
                  BPhil Philosophy, Ethics &amp; Psychological Sciences (Cum
                  Laude)
                  <br />
                  Brainwave Recursive Therapy Level 1, (BWRT® SA)
                  <br />
                  Makaton Level 2 (Makaton SA)
                </strong>
              </blockquote>
            </div>
            <div className="introduction-text">
              <p>
                What draws me to counselling is the quiet courage that people
                show when they allow themselves to be seen and to be vulnerable.
                That moment when someone chooses honesty over armour is where
                the real work begins.
              </p>
              <p>
                In the counselling space, I bring curiosity, calmness and
                respect. I work collaboratively, guiding the process while
                honouring your pace and your lived experience.
              </p>
              <p>
                Working with neurodiverse and learning challenged children in a
                school setting has taught me to slow down, listen deeply, and
                honour the diverse ways in which growth unfolds.
              </p>
              <p>
                Walking alongside my clients to explore their subject choices
                and career choices gives me the privilege of witnessing their
                selfunderstanding and emerging sense of direction.
              </p>
              <p>
                I am a passionate and competitive equestrian athlete. I have
                felt performance anxiety, and I have experienced the
                disappointments and stress that sport can bring. These
                experiences have led to special interest in sport psychology.
              </p>
              <p>
                My practice is built on a deep commitment to supporting each
                individual&#39;s journey toward healing and growth. I believe in
                empowering clients to draw on their own strengths and resources,
                trusting that people are far more resilient than they often
                realise.
              </p>
              <p>
                It will be my honour to walk alongside you as you navigate
                life’s challenges and transitions, and to witness the bravery it
                takes to grow, heal and live with greater authenticity.
              </p>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
